export const SPACE_THREAD_LIMIT = 5;
export function getPinnedFirstSpaceThreads({ pinnedThreads, recentThreads, }) {
    const seenContextUuids = new Set();
    return [...pinnedThreads, ...recentThreads]
        .filter((thread) => {
        if (!thread.context_uuid || seenContextUuids.has(thread.context_uuid)) {
            return false;
        }
        seenContextUuids.add(thread.context_uuid);
        return true;
    })
        .slice(0, SPACE_THREAD_LIMIT);
}
//# sourceMappingURL=SpaceItemsSharedSupport.js.map